import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Brands from './components/Brands';
import WhatWeDo from './components/WhatWeDo';
import Partnerships from './components/Partnerships';
import Careers from './components/Careers';
import Approach from './components/Approach';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="bg-background-50 text-foreground-950 antialiased">
      <Navbar />
      <Hero />
      <About />
      <Brands />
      <WhatWeDo />
      <Partnerships />
      <Careers />
      <Approach />
      <Contact />
      <Footer />
    </main>
  );
}